import api from "@/api.js";
import featuredEntriesBenefits from "./featuredEntriesBenefits/"
import featuredListings from './featuredListings'

export default {
  namespaced: true,
  modules: {
    featuredEntriesBenefits,
    featuredListings
  },
  state: {
    list: [],
    listLoading: false,
    selectedFindEntry: null
  },
  mutations: {
    setList(state, payload) {
      state.list = payload
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setSelectedFindEntry(state, payload) {
      state.selectedFindEntry = payload
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("solutions/findEntries");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadFindEntryByID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get('solutions/findEntries/byID', { params: { id: id } })
      commit('setSelectedFindEntry', list.data[0]);
      commit("setListLoading", false);
    },
    async loadAllBySolutionsID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("solutions/findEntries/bySolutionsID", {
        params: { id: id }
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllBySolutionsIDWithLikes({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("solutions/findEntries/bySolutionsIDWithLikes", {
        params: { id: id }
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("solutions/findEntries", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAllBySolutionsID", payload.solutions_id);
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`solutions/findEntries`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAllBySolutionsID", payload.solutions_id);
      return returnData;
    }
  },
  getters: {
    list: (state) => state.list,
    listLoading: (state) => state.listLoading,
    selectedFindEntry: (state) => state.selectedFindEntry

  }
}
